import React, { useState, useMemo, ReactNode, useEffect } from 'react'
import { useAuth } from '../zustand/auth.store';

// create context
export const ProductContext = React.createContext<valueItf | null>(null)


interface valueItf {
  isProductOpen: boolean;
  toggleProduct: () => void;
  closeProduct: () => void;
}
interface ProductITF {
  children: ReactNode
}

const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

export const ProductProvider = ({ children }: ProductITF) => {
  const profile = useAuth((s) => s.profile);
  const [isProductOpen, setIsProductOpen] = useState(false)
  const [isKycOpen, setIsKycOpen] = useState(false)


  function toggleProduct() {
    setIsProductOpen(!isProductOpen)
  }

  function toggleKyc() {
    setIsKycOpen((prev) => !prev)
    // setIsKycOpen(false)
  }
  // UPDATE THE KYC STATE WHEN THE CONTEXT UPDATES
  useEffect(() => {
    if (profile?.kycVerificationStatus === "verified") {
      setIsKycOpen(false);
    } else if (profile?.kycVerificationStatus && profile.kycVerificationStatus !== "verified") {
      setIsKycOpen(true);
    }
  }, [profile?.kycVerificationStatus]);

  function closeProduct() {
    setIsProductOpen(false)
  }

  function closeKyc() {
    setIsKycOpen(false)
  }

  const value = useMemo(
    () => ({
      isProductOpen,
      isKycOpen,
      toggleProduct,
      toggleKyc,
      closeProduct,
      closeKyc
    }),
    [isProductOpen, isKycOpen]
  )



  // Product after 5min of idleness 5 * 60 * 1000 = 300000




  return <ProductContext.Provider value={value}>{children}</ProductContext.Provider>
}